/*eslint-disable*/

import { FovTypography } from 'components';
import { IconButton, NameContainer, TableThumbnail } from 'pages/ArchVisionAdminDashboard/styles';
import { PeopleOutlined } from 'components/icons';


export const modelListColumns = () => ([
    {
        title: 'Thumbnail',
        key: 'thumbnail',
        width: 110,
        alignContent: 'center',
        render: (text, model) => {
            const { previewURL, preview256URL, preview512URL } = model;
            return (
                <TableThumbnail src={preview256URL || preview512URL || previewURL} />
            );
        },
    },
    {
        title: 'Title',
        key: 'title',
        width: 300,
        alignContent: 'left',
        render: (text, model) => (
            <NameContainer>
                <div>{model.title}</div>
            </NameContainer>
        ),
    },
    {
        title: 'Category',
        key: 'category',
        width: 120,
        render: (text, model) => (
            <NameContainer>
                <FovTypography fontSize={16}>{model.category}</FovTypography>
                {model.subcategory && <FovTypography fontSize={12}>└ {model.subcategory}</FovTypography>}
            </NameContainer>
        ),
    },
    {
        title: 'Creator',
        key: 'creator',
        width: 125,
        render: (text, model) => {
            return model.creator
                ? <FovTypography>{model.creator}</FovTypography>
                : '';
        },
    },
]);

export const listColumns = (theme, selectedTheme, setSelectedOrg) => ([
    {
        title: 'Organization Name',
        key: 'name',
        width: 300,
        alignContent: 'left',
        render: (text, organization) => {
            return (
                <NameContainer>
                    <div>{organization.name}</div>
                    <FovTypography fontSize={12}>({organization.id})</FovTypography>
                </NameContainer>
            );
        },
    },
    {
        title: 'Seats',
        key: 'seats',
        width: 100,
        alignContent: 'left',
        render: (text, organization) => (
            <FovTypography>{organization.occupiedSeats}/{organization.max_seats}</FovTypography>
        ),
    },
    {
        title: 'Profile',
        key: 'profile',
        render: (text, organization) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => {
                    setSelectedOrg(organization);
                }}
                icon={<PeopleOutlined title='Access organization profile'/>}
            />
        ),
    },
]);